import { Component, computed, input, output } from '@angular/core';
import { MDIconComponent } from '@melodic-ui/components';

type Sentiment = 'error' | 'warning' | 'neutral' | 'success' | 'brand';

interface EmojiScaleIcon {
	icon: string;
	sentiment: Sentiment;
}

const ALL_ICONS: EmojiScaleIcon[] = [
	{ icon: 'untitled-ui/users/face-sad', sentiment: 'error' },
	{ icon: 'untitled-ui/users/face-frown', sentiment: 'warning' },
	{ icon: 'untitled-ui/users/face-neutral', sentiment: 'neutral' },
	{ icon: 'untitled-ui/users/face-smile', sentiment: 'success' },
	{ icon: 'untitled-ui/users/face-happy', sentiment: 'brand' }
];

const SCALE_SUBSETS: Record<number, number[]> = {
	3: [0, 2, 4],
	4: [0, 1, 3, 4],
	5: [0, 1, 2, 3, 4]
};

@Component({
	selector: 'lb-emoji-scale',
	standalone: true,
	imports: [MDIconComponent],
	templateUrl: './emoji-scale.component.html',
	styleUrl: './emoji-scale.component.scss'
})
export class EmojiScaleComponent {
	scaleSize = input<number>(5);
	value = input<string | null>(null);
	readonly = input<boolean>(false);

	valueChange = output<string>();

	icons = computed<EmojiScaleIcon[]>(() => {
		const size = this.scaleSize();
		const indices = SCALE_SUBSETS[size] ?? SCALE_SUBSETS[5];
		return indices.map((i) => ALL_ICONS[i]);
	});

	isSelected(index: number): boolean {
		return this.value() === String(index + 1);
	}

	select(index: number): void {
		if (this.readonly()) return;
		this.valueChange.emit(String(index + 1));
	}
}
